<template>
	<div class="modal-wrapper" @click="close">
		<div class="modal-container" @click.stop.prevent="() => false">
			<div class="modal-header">
				<div class="row">
					<div class="col-xs-12">
						EDITAR ENTREGAS - {{ journey.vehicleLicensePlate }}
						<button class="modal-close" @click="close"><i class="fa fa-times"></i></button>
					</div>
				</div>
			</div>
			<div class="modal-body">
				<div class="container-list">
					<div v-if="loading" class="row">
						<div class="col-xs-12 col-lg-12">
							<div class="loading loading-full">
								<span class="loading-icon"><i class="fa fa-circle-notch fa-spin"></i></span>
								<span class="loading-text">Otimizando cargas e rotas...</span>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<div class="row">
								<div class="col-xs-12">
									<p class="description"><b><i class="fa fa-fw fa-info-circle"></i> Arraste e solte</b> as entregas entre as listas para editar</p>
								</div>
								<div v-if="($parent.data.base.vehicles.length > 1) && showVehicleSelect" class="col-xs-12">
									<div class="row">
										<div class="col-xs-12">
											<p class="description-vehicle-selected">Deseja rearranjar com as entregas de outro veículo?</p>
										</div>
									</div>
									<div class="row vehicle-selected">
										<div class="col-xs-8 col-lg-3">
											<FormSelect v-model="vehicleSelectedId" label="Veículo" :options="processVehicleList()" icon="fa-truck" tooltip="Informe o veículo que deseja editar junto com o veículo atual" />
										</div>
										<div class="col-xs-4 col-lg-1">
											<button class="button-edit button-select" @click="processVehicleSelectedNodesList()"><i class="fa fa-fw fa-check"></i> SELECIONAR</button>
										</div>
									</div>
								</div>
								<div class="col-xs-12 list-left" :class="showVehicleSelectedNodesList ? 'col-lg-4' : 'col-lg-6'">
									<span><i class="fa fa-fw fa-exchange-alt"></i></span>
									<div class="row">
										<div class="col-xs-12 col-lg-12">
											<p class="table-description"><i class="fa fa-fw fa-truck-loading"></i> Lista de entregas roteirizadas do veículo <b>{{ journey.vehicleLicensePlate }}</b>:</p>
										</div>
									</div>
									<div class="row list-group-title-item">
										<div class="col-xs-2 col-lg-2">ATUAL</div>
										<div class="col-xs-2 col-lg-2">NÚMERO</div>
										<div class="col-xs-6 col-lg-6">CLIENTE</div>
										<div class="col-xs-2 col-lg-2">PESO</div>
									</div>
									<div class="list-group" ref="nodesList" :style="{'height': maxHeight }">
										<div class="row list-group-item list-group-item-node pointer" v-for="(point, index) in nodesList" :key="'node_' + index" :data-document="point.documentIdentifier" :data-weight="point.weight"  ref="listGroupItemNode">
											<div class="col-xs-2 col-lg-2 list-group-item-col">{{ point.sequence }}</div>
											<div class="col-xs-2 col-lg-2 list-group-item-col">{{ point.documentNumber }}</div>
											<div class="col-xs-6 col-lg-6 list-group-item-col capitalized">
												{{ point.customerName.toLowerCase() }} <br/>
												<span v-if="client_atak && (point.movimentTypeCode == default_moviment_type_code)" class="stopping-item"><b><i class="fas fa-exclamation-triangle"></i> Ponto de parada</b></span>
											</div>
											<div class="col-xs-2 col-lg-2 list-group-item-col">{{ point.weight ? getWeight(point.weight) : "0,00 kg" }}</div>
											<div v-if="point.observationID" class="col-xs-2 col-lg-12 list-group-item-col"><p class="description-item"><b><i class="fa fa-fw fa-info-circle"></i> Observação:</b> {{ point.observation }}</p></div>
										</div>
									</div>
								</div>
								<div v-show="showVehicleSelectedNodesList" class="col-xs-12 list-left col-lg-4">
									<span><i class="fa fa-fw fa-exchange-alt"></i></span>
									<div class="row">
										<div class="col-xs-12 list-vehicle-selected">
											<div class="row">
												<div class="col-xs-12 col-lg-12">
													<p class="table-description"><i class="fa fa-fw fa-truck-loading"></i> Lista de entregas roteirizadas do veículo <b>{{ showVehicleSelectedNodesList ? vehicleSelected.vehicleLicensePlate : "" }}</b>:</p>
												</div>
											</div>
											<div class="row list-group-title-item">
												<div class="col-xs-2 col-lg-2">ATUAL</div>
												<div class="col-xs-2 col-lg-2">NÚMERO</div>
												<div class="col-xs-6 col-lg-6">CLIENTE</div>
												<div class="col-xs-2 col-lg-2">PESO</div>
											</div>
											<div class="list-group list-group-vehicle-selected" ref="vehicleSelectedNodesList" :style="{'height': maxHeight }">
												<div class="row list-group-item list-group-item-selected pointer" v-for="(point, index) in vehicleSelectedNodesList" :key="'node_vehicle_selected_' + index" :data-document="point.documentIdentifier" :data-weight="point.weight"  ref="listGroupItemSelected">
													<div class="col-xs-2 col-lg-2 list-group-item-col">{{ point.sequence }}</div>
													<div class="col-xs-2 col-lg-2 list-group-item-col">{{ point.documentNumber }}</div>
													<div class="col-xs-6 col-lg-6 list-group-item-col capitalized">
														{{ point.customerName.toLowerCase() }}<br/>
														<span v-if="client_atak && (point.movimentTypeCode == default_moviment_type_code)" class="stopping-item"><b><i class="fas fa-exclamation-triangle"></i> Ponto de parada</b></span>
													</div>
													<div class="col-xs-2 col-lg-2 list-group-item-col">{{ point.weight ? getWeight(point.weight) : "0,00 kg" }}</div>
													<div v-if="point.observationID" class="col-xs-2 col-lg-12 list-group-item-col"><p class="description-item"><b><i class="fa fa-fw fa-info-circle"></i> Observação:</b> {{ point.observation }}</p></div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-xs-12" :class="showVehicleSelectedNodesList ? 'col-lg-4' : 'col-lg-6'">
									<div class="row">
										<div class="col-xs-12">
											<div class="row">
												<div class="col-xs-12 col-lg-12">
													<p class="table-description"><i class="fa fa-fw fa-boxes"></i> Lista de entregas <b>desvinculadas</b>:</p>
												</div>
											</div>
											<div class="row list-group-title-item">
												<div class="col-xs-2 col-lg-2">ATUAL</div>
												<div class="col-xs-2 col-lg-2">NÚMERO</div>
												<div class="col-xs-6 col-lg-6">CLIENTE</div>
												<div class="col-xs-2 col-lg-2">PESO</div>
											</div>
											<div class="list-group" ref="droppedNodesList" :style="{'height': maxHeight }">
												<div class="row list-group-item list-group-item-dropped pointer" v-for="(point, index) in droppedNodesList" :key="'droppedNode_' + index" :data-document="point.documentIdentifier" :data-weight="point.weight" ref="listGroupItemDropped">
													<div class="col-xs-2 col-lg-2 list-group-item-col">#</div>
													<div class="col-xs-2 col-lg-2 list-group-item-col">{{ point.documentNumber }}</div>
													<div class="col-xs-6 col-lg-6 list-group-item-col capitalized">
														{{ point.customerName.toLowerCase() }}<br/>
														<span v-if="client_atak && (point.movimentTypeCode == default_moviment_type_code)" class="stopping-item"><b><i class="fas fa-exclamation-triangle"></i> Ponto de parada</b></span>
													</div>
													<div class="col-xs-2 col-lg-2 list-group-item-col">{{ point.weight ? getWeight(point.weight) : "0,00 kg" }}</div>
													<div v-if="point.observationID" class="col-xs-2 col-lg-12 list-group-item-col"><p class="description-item"><b><i class="fa fa-fw fa-info-circle"></i> Observação:</b> {{ point.observation }}</p></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="row">
					<div class="col-xs-12" :class="showVehicleSelectedNodesList ? 'col-lg-4' : 'col-lg-4'">
						<div class="row">
							<div class="col-xs-12">
								<p class="description-weight">Veículo <b>{{ journey.vehicleLicensePlate }}</b></p>
							</div>
							<div class="col-xs-4 col-lg-4 total-weight">
								<span class="total-weight-percent" ref="totalWeightPercent">{{ totalWeightPercent.toFixed(1) }} %</span>
							</div>
							<div class="col-xs-8 col-lg-8 total-weight">
								<i class="fa fa-fw fa-truck-loading"></i> {{ getWeight(totalWeight) }} / <i class="fa fa-fw fa-truck"></i> {{ getWeight(vehicleWeightCapacity) }}
							</div>
						</div>
					</div>
					<div v-show="showVehicleSelectedNodesList" class="col-xs-12 col-lg-4">
						<div class="row">
							<div class="col-xs-12">
								<p class="description-weight">Veículo <b>{{ showVehicleSelectedNodesList ? vehicleSelected.vehicleLicensePlate : "" }}</b></p>
							</div>
							<div class="col-xs-4 col-lg-4 total-weight">
								<span class="total-weight-percent" ref="vehicleSelectedTotalWeightPercent">{{ vehicleSelectedTotalWeightPercent.toFixed(1) }} %</span>
							</div>
							<div class="col-xs-8 col-lg-8 total-weight">
								<i class="fa fa-fw fa-truck-loading"></i> {{ getWeight(vehicleSelectedTotalWeight) }} / <i class="fa fa-fw fa-truck"></i> {{ getWeight(vehicleSelectedWeightCapacity) }}
							</div>
						</div>
					</div>
					<div class="col-xs-12 col-lg-2" :class="showVehicleSelectedNodesList ? 'col-lg-offset-2' : 'col-lg-offset-6'">
						<button class="button-route" @click="updateRoute" :disabled="loading">
							<i :class="'fa fa-fw' + (loading ? ' fa-circle-notch fa-spin' : ' fa-sync-alt')"></i> ATUALIZAR
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Sortable, { MultiDrag } from "sortablejs";
import FormSelect from "@/components/FormSelect";

Sortable.mount(new MultiDrag());

export default {
	name: "RoutingModalEdit",

	props: {
		journey: {
			type: Object,
			require: true,
		},
		journeyIndex: {
			type: Number,
			require: true,
		},
		journeyHasRoute: {
			type: Boolean,
			require: true,
		},
		droppedNodes: {
			type: Array,
			require: true,
		},
		client_atak: {
			type: [Number, Boolean],
			require: true,
		},
		default_moviment_type_code: {
			type: String,
			require: false,
			default: "",
		},
	},

	components: {
		FormSelect,
	},

	data: function() {
		return {
			loading: false,
			nodes: [],

			dcPoint: null,
			returnDcPoint: null,
			nodesList: [],
			droppedNodesList: [],
			sortableNodes: null,
			sortableDroppedNodes: null,
			sortableNodesVehicleSelected: null,
			pointsWithZeroWeight: 0,
			vehicleWeightCapacity: 0,
			totalWeight: 0,
			totalWeightPercent: 0,
			
			showVehicleSelect: true,
			vehicleSelectedId: "",
			vehicleSelected: null,
			vehicleSelectedHasRoute: false,
			showVehicleSelectedNodesList: false,
			vehicleSelectedDCPoint: null,
			vehicleSelectedReturnDCPoint: null,
			vehicleSelectedNodesList: [],
			vehicleSelectedPointsWithZeroWeight: 0,
			vehicleSelectedTotalWeight: 0,
			vehicleSelectedTotalWeightPercent: 0,
			vehicleSelectedWeightCapacity: 0,

			maxHeight: "100%",
		}
	},

	mounted: function() {
		// Define a capacidade do veículo
		this.processNodesList();
		this.processDroppedNodesList();
		this.processWeight();
		this.initSorteable();
	},

	updated: function() {
		this.calcHeight();
	},

	watch: {
		totalWeight: function() {
			this.processWeight();
		},
		
		vehicleSelectedTotalWeight: function() {
			this.processWeightVehicleSelected();
		}
	},

	methods: {
		/**
		 * Processa a lista de entregas roteirizadas
		 */
		processNodesList: function() {
			// Percorre a lista dos pontos de entrega
			this.journey.points.map((point, index)=> {
				// Verifica se é um ponto de entrega
				if(!point.isDC) {
					// Adiciona na lista geral
					this.nodes.push(point);

					// Adiciona na lista de entregas
					this.nodesList.push(point);
					
					// Soma o peso ao total da carga
					this.totalWeight += point.weight;
				} else {
					// Verifica se é a posição do centro de distribuição
					if(index == 0) {
						// Salva o ponto do dc
						this.dcPoint = point;
					} else {
						this.returnDcPoint = point;
					}
				}
			});
		},
		
		/**
		 * Processa a lista de entregas desvinculadas
		 */
		processDroppedNodesList: function() {
			// Percorre a lista dos pontos de entregas desvinculadas
			this.droppedNodes.map(point => {
				// Adiciona na lista geral
				this.nodes.push(point);

				// Adiciona na lista de desvinculadas
				this.droppedNodesList.push(point);
			});
		},
		
		/**
		 * Processa o peso e capacidade
		 */
		processWeight: function () {
			this.vehicleWeightCapacity = parseInt(this.journey.vehicleWeightCapacity);

			//if(this.journey.weightConstraints) {
				this.totalWeightPercent = (this.totalWeight * 100) / this.vehicleWeightCapacity;
			/*} else {
				this.totalWeightPercent = 0;
			}*/
			
			let backgroundColor = "";
			let borderColor = "";
			if(this.totalWeightPercent <= 50) {
				backgroundColor = "#64ff64";
				borderColor = "#0dac0d";
			} else if((this.totalWeightPercent > 50) && (this.totalWeightPercent < 90)) {
				backgroundColor = "#ffc965";
				borderColor = "#b77c10";
			} else {
				backgroundColor = "#faa";
				borderColor = "#f55";
			}

			this.$refs.totalWeightPercent.style.background = "linear-gradient(90deg, " + backgroundColor + " " + this.totalWeightPercent + "%, white " + this.totalWeightPercent + "%)";
			this.$refs.totalWeightPercent.style.borderColor = borderColor;
		},
		
		/**
		 * Inicia o componente sorteable nas lista
		 */
		initSorteable: function() {
			// Lista das entregas roteirizadas
			this.sortableNodes = new Sortable(this.$refs.nodesList, {
				group: "shared",
				sort: true,
				multiDrag: true,
				selectedClass: "item-selected",
				fallbackTolerance: 3,
				animation: 150,
				dataIdAttr: "data-document",
				onAdd: (evt) => {
					// Verifica a quantidade de registros adicionados
					if(evt.items.length > 0) {
						// Atualiza o peso
						evt.items.map(item => {
							let weight = parseFloat(item.dataset.weight);
							this.totalWeight += weight;
						});
					} else {
						// Atualiza o peso
						let weight = parseFloat(evt.item.dataset.weight);
						this.totalWeight += weight;
					}
					
					// Percorre a lista modificada
					this.sortableNodes.toArray().forEach((document, index) => {
						// Percorre a lista de pontos
						for (let i = 0; i < this.nodes.length; i++) {
							if (this.nodes[i].documentIdentifier == document) {
								this.nodes[i].sequence = index + 1;
								this.nodes[i].packageSequence = this.nodes.length - index;
								break;
							}
						}
					});
				},
				onRemove: (evt) => {
					// Verifica a quantiade de registros removodos
					if(evt.items.length > 0) {
						// Atualiza o peso
						evt.items.map(item => {
							let weight = parseFloat(item.dataset.weight);
							this.totalWeight -= weight;
						});
					} else {
						// Atualiza o peso
						let weight = parseFloat(evt.item.dataset.weight);
						this.totalWeight -= weight;
					}

					// Percorre a lista modificada
					this.sortableNodes.toArray().forEach((document, index) => {
						// Percorre a lista de pontos
						for (let i = 0; i < this.nodes.length; i++) {
							if (this.nodes[i].documentIdentifier == document) {
								this.nodes[i].sequence = index + 1;
								this.nodes[i].packageSequence = this.sortableNodes.toArray().length - index;
								break;
							}
						}
					});
				},
				onSort: () => {
					// Percorre a lista modificada
					this.sortableNodes.toArray().forEach((document, index) => {
						// Percorre a lista de pontos
						for (let i = 0; i < this.nodes.length; i++) {
							if (this.nodes[i].documentIdentifier == document) {
								this.nodes[i].sequence = index + 1;
								this.nodes[i].packageSequence = this.sortableNodes.toArray().length - index;
								break;
							}
						}
					});
				},
				onEnd: () => {
					this.calcHeight();
				},
			});

			// Lista das entregas desvinculadas
			this.sortableDroppedNodes = new Sortable(this.$refs.droppedNodesList, {
				group: "shared",
				sort: false,
				multiDrag: true,
				selectedClass: "item-selected",
				fallbackTolerance: 3,
				animation: 150,
				dataIdAttr: "data-document",
				onEnd: () => {
					this.calcHeight();
				},
			});
		},
		

		/**
		 * Obtem as informações do veículo selecionado e exibe a sua lista de entregas
		 */
		processVehicleSelectedNodesList: function() {
			// Verifica se foi selecionado
			if(this.vehicleSelectedId != "") {
				// Identifica as informações na lista de veículos com rota
				this.$parent.journeyWithRouteList.map(journey => {
					if(this.vehicleSelectedId == journey.id) {
						// Atualiza as informações
						this.vehicleSelected = journey;
						this.vehicleSelectedWeightCapacity = Math.ceil(journey.vehicleWeightCapacity);
						this.vehicleSelectedHasRoute = true;

						// Percorre os pontos
						journey.points.map((point, indexPoint) => {
							// Verifica se é um ponto de entrega
							if(!point.isDC) {
								// Adiciona na lista geral
								this.nodes.push(point);

								// Adiciona na lista de entregas
								this.vehicleSelectedNodesList.push(point);
								
								// Soma o peso ao total da carga
								this.vehicleSelectedTotalWeight += Math.ceil(point.weight);
							} else {
								// Verifica se é a posição do centro de distribuição
								if(indexPoint == 0) {
									// Salva o ponto do dc
									this.vehicleSelectedDCPoint = point;
								}
							}
						});
					}
				});
				
				// Verifica se já foi encontrado
				if(this.vehicleSelected == null) {
					// Identifica as informações na lista de veículos com rota
					this.$parent.journeyWithoutRouteList.map(journey => {
						if(this.vehicleSelectedId == journey.id) {
							// Atualiza as informações
							this.vehicleSelected = journey;
							this.vehicleSelectedWeightCapacity = Math.ceil(journey.vehicleWeightCapacity);
							this.vehicleSelectedHasRoute = false;

							// Percorre os pontos
							journey.points.map((point, indexPoint) => {
								// Verifica se é um ponto de entrega
								if(!point.isDC) {
									// Adiciona na lista geral
									this.nodes.push(point);

									// Adiciona na lista de entregas
									this.vehicleSelectedNodesList.push(point);
									
									// Soma o peso ao total da carga
									this.vehicleSelectedTotalWeight += Math.ceil(point.weight);
								} else {
									// Verifica se é a posição do centro de distribuição
									if(indexPoint == 0) {
										// Salva o ponto do dc
										this.vehicleSelectedDCPoint = point;
									} else {
										// Salva o ponto do dc
										this.vehicleSelectedReturnDCPoint = point;
									}
								}
							});
						}
					});
				}
				
				this.initSorteableVehicleSelected();
				this.processWeightVehicleSelected();

				// Atualiza a exibição
				this.showVehicleSelect = false;
				this.showVehicleSelectedNodesList = true;
			}
		},
		
		/**
		 * Processa o peso e capacidade
		 */
		processWeightVehicleSelected: function () {
			this.vehicleSelectedWeightCapacity = parseInt(this.vehicleSelected.vehicleWeightCapacity);

			//if(this.vehicleSelected.weightConstraints) {
				this.vehicleSelectedTotalWeightPercent = (this.vehicleSelectedTotalWeight * 100) / this.vehicleSelectedWeightCapacity;
			/*} else {
				this.vehicleSelectedTotalWeightPercent = 0;
			}*/

			let backgroundColor = "";
			let borderColor = "";
			if(this.vehicleSelectedTotalWeightPercent <= 50) {
				backgroundColor = "#64ff64";
				borderColor = "#0dac0d";
			} else if((this.vehicleSelectedTotalWeightPercent > 50) && (this.vehicleSelectedTotalWeightPercent < 90)) {
				backgroundColor = "#ffc965";
				borderColor = "#b77c10";
			} else {
				backgroundColor = "#faa";
				borderColor = "#f55";
			}

			this.$refs.vehicleSelectedTotalWeightPercent.style.background = "linear-gradient(90deg, " + backgroundColor + " " + this.vehicleSelectedTotalWeightPercent + "%, white " + this.vehicleSelectedTotalWeightPercent + "%)";
			this.$refs.vehicleSelectedTotalWeightPercent.style.borderColor = borderColor;
		},

		/**
		 * Inicia o componente sorteable na lista do veículo selecionado
		 **/
		initSorteableVehicleSelected: function() {
			// Lista das entregas do veículo selecionado
			this.sortableNodesVehicleSelected = new Sortable(this.$refs.vehicleSelectedNodesList, {
				group: "shared",
				sort: true,
				multiDrag: true,
				selectedClass: "item-selected",
				fallbackTolerance: 3,
				animation: 150,
				dataIdAttr: "data-document",
				onAdd: (evt) => {
					// Verifica a quantidade de registros adicionados
					if(evt.items.length > 0) {
						// Atualiza o peso
						evt.items.map(item => {
							let weight = parseFloat(item.dataset.weight);
							this.vehicleSelectedTotalWeight += weight;
						});
					} else {
						// Atualiza o peso
						let weight = parseFloat(evt.item.dataset.weight);
						this.vehicleSelectedTotalWeight += weight;
					}

					// Percorre a lista modificada
					this.sortableNodesVehicleSelected.toArray().forEach((document, index) => {
						// Percorre a lista de pontos
						for (let i = 0; i < this.nodes.length; i++) {
							if (this.nodes[i].documentIdentifier == document) {
								this.nodes[i].sequence = index + 1;
								this.nodes[i].packageSequence = this.sortableNodesVehicleSelected.toArray().length - index;
								break;
							}
						}
					});
				},
				onRemove: (evt) => {
					// Verifica a quantidade de registros removidos
					if(evt.items.length > 0) {
						// Atualiza o peso
						evt.items.map(item => {
							let weight = parseFloat(item.dataset.weight);
							this.vehicleSelectedTotalWeight -= weight;
						});
					} else {
						// Atualiza o peso
						let weight = parseFloat(evt.item.dataset.weight);
						this.vehicleSelectedTotalWeight -= weight;
					}

					// Percorre a lista modificada
					this.sortableNodesVehicleSelected.toArray().forEach((document, index) => {
						// Percorre a lista de pontos
						for (let i = 0; i < this.nodes.length; i++) {
							if (this.nodes[i].documentIdentifier == document) {
								this.nodes[i].sequence = index + 1;
								this.nodes[i].packageSequence = this.nodes.length - index;
								break;
							}
						}
					});
				},
				onSort: () => {
					// Percorre a lista modificada
					this.sortableNodesVehicleSelected.toArray().forEach((document, index) => {
						// Percorre a lista de pontos
						for (let i = 0; i < this.nodes.length; i++) {
							if (this.nodes[i].documentIdentifier == document) {
								this.nodes[i].sequence = index + 1;
								this.nodes[i].packageSequence = this.sortableNodesVehicleSelected.toArray().length - index;
								break;
							}
						}
					});
				},
				onEnd: () => {
					this.calcHeight();
				},
			});
		},
		
		/**
		 * Processa a lista de veículos
		 * @return {object} objeto com lista de veículos
		 **/
		processVehicleList: function() {
			let options = {};
			
			this.$parent.data.base.vehicles.map(vehicle => {
				if(vehicle.vehicleLicensePlate != this.journey.vehicleLicensePlate) {
					options[vehicle.id] = vehicle.vehicleLicensePlate;
				}
			});

			return options;
		},
		
		/**
		 * Calcula o tamanho padrão de altura das divs das listas de registros
		 */
		calcHeight: function() {
			let aux = 0;

			let listGroupItensNode = this.$refs.listGroupItemNode;
			if (listGroupItensNode) {
				listGroupItensNode.map((element) => {
					aux += element.clientHeight;
				});
				aux += listGroupItensNode.length * 10;
			}
			
			let listGroupItensDropped = this.$refs.listGroupItemDropped;
			if (listGroupItensDropped) {
				listGroupItensDropped.map((element) => {
					aux  += element.clientHeight;
				});
				aux  += listGroupItensDropped.length * 10;
			}
			
			if (this.showVehicleSelectedNodesList) {
				let listGroupItensSelected = this.$refs.listGroupItemSelected;
				if (listGroupItensSelected) {
					listGroupItensSelected.map((element) => {
						aux += element.clientHeight;
					});
					aux += listGroupItensSelected.length * 10;
				}
				
				this.maxHeight = aux > 0 ? aux + "px" : "100%";
			} else {
				this.maxHeight = aux > 0 ? aux + "px" : "100%";
			}
		},

		/**
		 * Obtem o peso formatado
		 * @param {number} weight 
		 */
		getWeight: function(weight) {
            let weight_formatted = "";

            if (weight < 1000) weight_formatted = weight.toFixed(2) + " kg";
            else weight_formatted = (weight / 1000).toFixed(2) + " t";

            return weight_formatted.replace(".", ",");
        },
		
		/**
		 * Processa a atualização da rota
		 */
		updateRoute: async function() {
			// Inicia as variávei necesárias
			let list = this.sortableNodes.toArray();
			let listDroppedNode = this.sortableDroppedNodes.toArray();
			let listVehicleSelected = this.showVehicleSelectedNodesList ? this.sortableNodesVehicleSelected.toArray() : [];
			
			let journeyResult = [];
			let droppedNodesListResult = [];
			
			let nodesListAux = [];
			let nodesListVehicleSelectedAux = [];
			
			// Adiciona o ponto do centro de distribuição
			nodesListAux.push(this.dcPoint);
			nodesListVehicleSelectedAux.push(this.vehicleSelectedDCPoint);
			
			// Percorre a lista de entregas
			this.nodes.map(point => {
				// Verifica se a entrega está na lista do veículo
				if(list.includes(point.documentIdentifier)) {
					// Verifica se o peso é 0
					if(Math.ceil(point.weight) == 0) {
						// Soma ao contador de entregas com peso 0
						this.pointsWithZeroWeight++;
					}
					// Adiciona a lista de entregas a serem roteirizadas
					nodesListAux.push(point);
				} else if(listDroppedNode.includes(point.documentIdentifier)) {
					// Adiciona a lista de entregas desvinculadas
					droppedNodesListResult.push(point);
				} else if(this.showVehicleSelectedNodesList && listVehicleSelected.includes(point.documentIdentifier)) {
					// Verifica se o peso é 0
					if(Math.ceil(point.weight) == 0) {
						// Soma ao contador de entregas com peso 0
						this.vehicleSelectedPointsWithZeroWeight++;
					}
					// Adiciona a lista de entregas a serem roteirizadas
					nodesListVehicleSelectedAux.push(point);
				}
			});
			
			// Adiciona a lista de entregas deste veículo
			journeyResult.push({
				index: this.journeyIndex,
				hasRoute: this.journeyHasRoute,
				journey: this.journey,
				totalWeight: this.totalWeight,
				pointsWithZeroWeight: this.pointsWithZeroWeight,
				points: nodesListAux,
				routing: true,
			});

			// Verifica se tem veículo selecionado
			if(this.showVehicleSelectedNodesList) {
				// Adiciona a lista de entregas deste veículo
				journeyResult.push({
					index: this.vehicleSelectedId,
					hasRoute: this.vehicleSelectedHasRoute,
					journey: this.vehicleSelected,
					totalWeight: this.vehicleSelectedTotalWeight,
					pointsWithZeroWeight: this.vehicleSelectedPointsWithZeroWeight,
					points: nodesListVehicleSelectedAux,
					routing: true,
				});
			}
			
			// Percorre a lista de veículos
			for(let item of journeyResult) {
				// Verifica se vai roteirizar algum nó
				if(item.points.length > 1) {
					// Verifica se já tinha rota
					if (item.hasRoute) {
						// Pede uma confirmação para ser roteirizado o conjunto de entregas
						let confirm = await this.$alert.confirm("Você pode optar por ROTEIRIZAR NOVAMENTE para otimizar a carga e rota do veículo " + item.journey.vehicleLicensePlate + ",  ou MANTER A SEQUÊNCIA ATUAL deste conjunto de entregas. Deseja roteirizar novamente o veículo " + item.journey.vehicleLicensePlate + "?", "AVISO");
						
						// Verifica a resposta
						if(!confirm) {
							// Informa que não será roteirizado novamente
							item.routing = false;

							// Atualiza a restrição de peso
							item.journey.timeConstraints = false;
							
							// Adiciona o ponto do centro de distribuição na volta
							if (this.journey.returnOrigin) nodesListAux.push(this.returnDcPoint);
							if (this.showVehicleSelectedNodesList && this.vehicleSelected.returnOrigin) nodesListVehicleSelectedAux.push(this.vehicleSelectedReturnDCPoint);

							// Continua o loop
							continue;
						}
					}

					// Verifica se tem restrição de peso
					if(item.journey.weightConstraints) {
						// Verifica se o peso total é menor ou igual a capacidade máxima do veículo e tem entregas com 0 de peso
						if((item.totalWeight <= item.journey.vehicleWeightCapacity) && (item.pointsWithZeroWeight > 0)) {
							// Pede uma confirmação
							let confirm = await this.$alert.confirm("Existem entregas sem o peso informado no veículo " + item.journey.vehicleLicensePlate + ". - SERÁ DESCONSIDERADA A RESTRIÇÃO DE PESO NESTE VEÍCULO - Deseja continuar?", "AVISO");
							
							// Verifica a resposta
							if(!confirm) {
								return;
							}

							// Atualiza a restrição de peso
							item.journey.weightConstraints = false;

						// Verifica se o peso total é maior que a capacidade máxima do veículo e não tem entregas com 0 de peso
						} else if((item.totalWeight > item.journey.vehicleWeightCapacity) && (item.pointsWithZeroWeight == 0)) {
							// Pede uma confirmação
							let confirm = await this.$alert.confirm("O peso total das entregas excedem a capacidade do máxima no veículo " + item.journey.vehicleLicensePlate + ". - SERÁ DESCONSIDERADA A RESTRIÇÃO DE PESO NESTE VEÍCULO - Deseja continuar?", "AVISO");
							
							// Verifica a resposta
							if(!confirm) {
								return;
							}

							// Atualiza a restrição de peso
							item.journey.weightConstraints = false;
							
						// Verifica se o peso total é maior que a capacidade máxima do veículo e tem entregas com 0 de peso
						} else if((item.totalWeight > item.journey.vehicleWeightCapacity) && (item.pointsWithZeroWeight != 0)) {
							// Pede uma confirmação
							let confirm = await this.$alert.confirm("O peso total das entregas excedem a capacidade do máxima no veículo " + item.journey.vehicleLicensePlate + ". Também, existem entregas sem o peso informado. - SERÁ DESCONSIDERADA A RESTRIÇÃO DE PESO NESTE VEÍCULO - Deseja continuar?", "AVISO");
							
							// Verifica a resposta
							if(!confirm) {
								return;
							}

							// Atualiza a restrição de peso
							item.journey.weightConstraints = false;
						}
					} else {
						// Verifica se o peso total é menor ou igual a capacidade máxima do veículo e não tem entregas com 0 de peso
						if((item.totalWeight <= item.journey.vehicleWeightCapacity) && (item.pointsWithZeroWeight == 0)) {
							// Pede uma confirmação
							let confirm = await this.$alert.confirm("Todas as entregas, relacionadas ao veículo " + item.journey.vehicleLicensePlate + ", tem o peso informado e estão dentro da capacidade. Deseja APLICAR A RESTRIÇÃO DE PESO NESTE VEÍCULO ?", "AVISO");
							
							// Verifica a resposta
							if(confirm) {
								// Atualiza a restrição de peso
								item.journey.weightConstraints = true;
							}
						}
					}

					// Verifica se tem restrição de tempo
					if(!item.journey.timeConstraints) {
						// Verifica se o o horário de início e fim da rota foi definido
						if ((typeof item.journey.points[1] != "undefined") && ((item.journey.points[1].startTime != "00:00" && item.journey.points[1].startTime != "00:00:00") && (item.journey.points[1].endTime != "00:00" && item.journey.points[1].endTime != "00:00:00"))) {
							// Pede uma confirmação
							let confirm = await this.$alert.confirm("A restrição de tempo está desativada para o veículo " + item.journey.vehicleLicensePlate + ", porém inicialmente está definido um horário de início e fim das entregas. Deseja APLICAR A RESTRIÇÃO DE TEMPO NESTE VEÍCULO ?", "AVISO");
							
							// Verifica a resposta
							if(confirm) {
								// Atualiza a restrição de peso
								item.journey.timeConstraints = true;
							}
						}
					}
				}
			}
			
			// Informa o carregamento
			this.loading = true;

			// Emite o resultado
			this.$emit("routing", [journeyResult, droppedNodesListResult]);
		},

		/**
		 * Fecha o modal
		 */
		close: function() {
			this.$emit("close");
		},
	}
}
</script>

<style scoped>
.modal-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: #00000044;
	z-index: 3;
}

.modal-container {
	position: absolute;
	width: calc(100vw - 30px);
	height: calc(100vh - 30px);
	margin: auto;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	border-radius: 4px;
}

.modal-header {
	position: relative;
	border-bottom: 1px solid #ddd;
	height: 50px;
	line-height: 50px;
	padding: 0px 15px;
	font-weight: bold;
	background: #f9f9f9;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.modal-close {
	position: absolute;
	top: 12px;
	right: 15px;
	font-size: 20px;
	background: none;
	border: none;
	color: #999;
}
.modal-body {
	padding: 15px;
	height: calc(100vh - 151px);
	width: 100%;
	overflow-y: auto;
}

.modal-footer {
	position: absolute;
	bottom: 0;
	height: auto;
	padding: 15px;
	width: 100%;
	border-top: 1px solid #ddd;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	overflow-x: hidden;
	overflow-y: auto;
}

p.description {
	margin-block-start: 0px;
	margin-block-end: 30px;
	padding: 5px;
	background-color: #ccc;
	border-radius: 4px;
	font-size: 12px;
}

p.description-item {
	margin-block-start: 10px;
	margin-block-end: 0px;
	padding: 5px;
	background-color: #ccc;
	border-radius: 4px;
	font-size: 12px;
}

p.description-weight {
	margin-block-start: 0px;
	margin-block-end: 0px;
	margin-top: 3px;
	font-size: 12px;
}

.vehicle-selected {
	margin-top: -10px;
}

p.description-vehicle-selected {
	margin-block-start: 0px;
}

p.table-description {
	margin-block-start: 0px;
	margin-block-end: 5px;
	font-size: 14px;
}

.list-left {
	position: relative;
	padding-right: 30px;
}

.list-left > span {
	position: absolute;
	right: 0;
	margin-top: 45px;
}

.list-right {
	position: relative;
	padding-left: 30px;
}

.list-right > span {
	position: absolute;
	left: 0;
	margin-top: 35px;
}

.list-group {
	width: 100%;
	height: 100%;
	text-align: left;
	border: 2px dashed #ddd;
	background-color: #fafafa;
}

.list-group-title-item {
	margin: 15px 0px 5px;
	font-size: 14px;
	border-top: 1px solid #ccc;
	border-bottom: 1px solid #ccc;
	padding-top: 5px;
	padding-bottom: 5px;
	background-color: #eee;
}

.list-group-item {
	margin: 5px 5px;
	padding-top: 10px;
	padding-bottom: 10px;
	border: 1px solid #ccc;
	border-radius: 3px;
	/*box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;*/
	background-color: #fff;
	font-size: 13px;
}

.list-group-item:hover {
	background-color: #f0f0f0;
}

.list-group-item-selected {
	background-color: #dbffdb;
}
.list-group-item-dropped {
	background-color: #ffe6da;
}

.list-group-item-col {
	display: grid;
	align-content: center;
}

.pointer {
	cursor: pointer;
}

.grab {
	cursor: -webkit-grab;
	cursor: grab;
}

.total-weight {
	padding-top: 3px;
	padding-bottom: 3px;
	font-size: 14px;
}

.total-weight-percent {
	display: block;
	padding: 1px 10px;
	color: #000;
	border: 1px solid;
	text-align: center;
	font-size: 12px;
}

.list-group-empty {
	margin-top: -90px;
	padding-top: 36px;
	padding-bottom: 36px;
	font-size: 12px;
	text-align: center;
	border: 2px dashed #ccc;
    border-radius: 3px;
}

.container-simbol {
	text-align: center;
	margin-bottom: 30px;
}

.container-simbol > i {
	margin-top: 30px;
}

.button-route {
	width: 100%;
	height: 40px;
	border: none;
	background: #222;
	color: #fff;
	font-weight: bold;
}

.item-selected {
	background-color: #f0f0f0;
}

.button-route:disabled {
	background: #a0a0a0
}
.button-select {
	margin-top: 30px;
	margin-right: 0px;
	width: 100%;
}

.loading {
    position: absolute;
    top: 50px;
    left: 0;
    background: rgba(255,255,255,.7);
    color: #222;
    text-align: center;
    font-family: Verdana;
    z-index: 10;
}

.loading-full {
    width: calc(100vw - 30px);
	height: calc(100vh - 141px);
    line-height: calc(100vh - 141px);
}

.loading-icon {
    border-top: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #f5f5f5;
    padding: 20px 5px 20px 20px;
    font-size: 20px;
    z-index: 10;
}

.loading-text {
    border-top: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background-color: #f5f5f5;
    padding: 20px 20px 20px 5px;
    font-size: 20px;
    z-index: 10;
}

span.stopping-item {
	margin-top: 5px;
    padding: 5px;
    border-radius: 4px;
    background-color: #ccc;
    color: #404040;
    font-size: 10px;
    width: max-content;
}
</style>